/* Local dependencies */
import { Order } from '../../../shared/types';
import {
    ResetError,
    UpdateOrderActionTypes,
    UpdateOrderError,
    UpdateOrderInput,
    UpdateOrderRequest,
    UpdateOrderSuccess,
} from './types';

export function updateOrder(input: UpdateOrderInput): UpdateOrderRequest {
  return {
    type: UpdateOrderActionTypes.UPDATE_ORDER_REQUEST,
    input,
  };
}

export function updateOrderSuccess(order: Order): UpdateOrderSuccess {
  return {
    type: UpdateOrderActionTypes.UPDATE_ORDER_SUCCESS,
    order,
  };
}

export function updateOrderError(error: Error): UpdateOrderError {
  return {
    type: UpdateOrderActionTypes.UPDATE_ORDER_ERROR,
    error,
  };
}

export function resetError(): ResetError {
  return {
    type: UpdateOrderActionTypes.RESET_ERROR,
  };
}

